import type {
  EventRegistrationConfig,
  EventRegistrationSettings,
  EventRegistrationsResponse,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const registrationsApi = {
  async settings(businessId: string, eventId: string): Promise<EventRegistrationSettings> {
    const res = await api.api.businesses[':businessId'].events[':eventId'].registration.$get({
      param: { businessId, eventId },
    })
    return unwrap<EventRegistrationSettings>(res)
  },

  async save(
    businessId: string,
    eventId: string,
    config: EventRegistrationConfig,
  ): Promise<EventRegistrationSettings> {
    const res = await api.api.businesses[':businessId'].events[':eventId'].registration.$put({
      param: { businessId, eventId },
      json: config,
    })
    return unwrap<EventRegistrationSettings>(res)
  },

  async list(businessId: string, eventId: string): Promise<EventRegistrationsResponse> {
    const res = await api.api.businesses[':businessId'].events[':eventId'].registrations.$get({
      param: { businessId, eventId },
    })
    return unwrap<EventRegistrationsResponse>(res)
  },

  async exportCsv(businessId: string, eventId: string): Promise<Blob> {
    const res = await api.api.businesses[':businessId'].events[
      ':eventId'
    ].registrations.export.$get({ param: { businessId, eventId } })
    if (!res.ok) await unwrap<never>(res)
    return res.blob()
  },

  async cancel(businessId: string, eventId: string, registrationId: string): Promise<void> {
    const res = await api.api.businesses[':businessId'].events[':eventId'].registrations[
      ':registrationId'
    ].$delete({ param: { businessId, eventId, registrationId } })
    await unwrap<void>(res)
  },
}
